import React, { Component } from 'react'

class VideoSlider extends Component {
  constructor(props) {
    super(props)

    this.state = {
      device:
        props.userAgent.toLowerCase().indexOf('mobile') > -1
          ? 'mobile'
          : 'desktop'
    }
  }

  render() {
    const code =
      '<script type="application/javascript" src="https://a.magsrv.com/video-slider.js"></script>\n' +
      '    <script type="application/javascript">\n' +
      '      var adConfig = {\n' +
      '        "idzone": "5182274",\n' +
      '        "frequency_period": 360,\n' +
      '        "close_after": 0,\n' +
      '        "sound_enabled": 0,\n' +
      '        "on_complete": "repeat",\n' +
      '        "branding_enabled": 0,\n' +
      '        "screen_density": 25,\n' +
      '        "cta_enabled": 1\n' +
      '      };\n' +
      '      ExoVideoSlider.init(adConfig);\n' +
      '    </script>'

    return <div dangerouslySetInnerHTML={{ __html: code }} />
  }
}

export default VideoSlider
